<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card color="grey lighten-5">
        <v-card-title
          class="text-h5 primary white--text"
          v-text="`Confirmar dados da Inscrição`"
        />

        <!--Dados Do Aluno-->
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <span class="font-weight-medium"
                  ><strong>DADOS PESSOAIS:</strong></span
                >
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text">Matrícula:</span>
                {{ student.codigo }}
              </v-col>

              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"
                  >Nome Completo:</span
                >
                {{ student.nome }}
              </v-col>

              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text">Unidade:</span>
                {{ student.nomeUnidade }}
              </v-col>

              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text">Etapa:</span>
                {{ student.nomeEtapa }}
              </v-col>

              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"> Rua:</span>
                {{ student.endereco.rua }}
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"> N°:</span>
                {{ student.endereco.numero }}
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"> Bairro:</span>
                {{ student.endereco.bairro }}
              </v-col>
              <v-col cols="12" class="pa-1">
                <span class="font-weight-medium primary--text"> CEP:</span>
                {{ student.endereco.cep }}
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!--Dados Do Aluno FIM-->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" text @click="$emit('close')">
            CANCELAR
          </v-btn>
          <v-btn color="green" :loading="saving" text @click="$emit('save')">
            SALVAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      disabled: true,
      checkbox: true,
      headers: [
        {
          align: "start",
        },

        { text: "Nome", value: "nome" },
      ],
    };
  },
};
</script>
